import { get, post } from '../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../config'

// 获取图形验证码
export const GET_CAPTCHA = () => {
  return get(`${OPERATION_CENTER_PREFIX}/sys/captcha`)
}

// 登录
export const USER_LOGIN = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/sys/login`, data)
}

// 登录
export const USER_LOGOUT = () => {
  return post(`${OPERATION_CENTER_PREFIX}/sys/logout`)
}

// 获取当前用户信息
export const USER_INFO = () => {
  return get(`${OPERATION_CENTER_PREFIX}/sys/user/info`)
}
